import React, { useEffect, useMemo, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  Button,
  Form,
  Input,
  Select,
  Radio,
  Space,
  Checkbox,
  TimePicker,
} from "antd";
import { Col, Row } from "react-bootstrap";
import { useMediaQuery } from "@mui/material";
import infoIcon from "../../../../assets/images/png/info.png";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import plusIcon from "../../../../assets/images/svg/newDesign/addIcon.svg";
import deleteIcon from "../../../../assets/images/png/delete_icon.png";
import styled from "styled-components";
import { APIV3 } from "../../../../utils/customAxios";
import moment from "moment";
import { isBrowser } from "react-device-detect";
import arrowIcon from "../../../../assets/images/svg/arrowIcon.svg";
import { MdBorderColor } from "react-icons/md";

dayjs.extend(customParseFormat);

const { Option } = Select;

let index = 0;

const VideoConsultation = (props) => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const [addslots, setAddSlots] = useState(1);
  const [addTimeslots, setAddTimeslots] = useState([{}]);
  const [addDays, setAddDays] = useState(1);
  const [addTime, setAddTime] = useState([{}]);
  const [mins, setMins] = useState("");
  const [fees, setFees] = useState("");
  const [clinicFees, setClinicFees] = useState("");
  const [clinicMins, setClinicMins] = useState("");
  const [hospital, setHospital] = useState("");
  // const [videoStartTime, setVideoStartTime] = useState("");
  // const [videoEndTime, setVideoEndTime] = useState("");
  const [anotherStartTime, setAnotherStartTime] = useState("");
  const [anotherEndTime, setAnotherEndTime] = useState("");
  const [clinics, setClinics] = useState([]);
  const [consultationMinutes, setConsultationMinutes] = useState([]);
  const [redField, setRedField] = useState(false);

  const {
    videoClinics,
    setVideoClinics,
    videoSlots,
    setVideoSlots,
    videoTimeSlots,
    setVideoTimeSlots,
    clinicVisit,
    setClinicVisit,
    clinicSlots,
    setClinicSlots,
    clinicTimeSlots,
    setClinicTimeSlots,
    videoClinicCheckbox,
    setVideoClinicCheckbox,
    videoConsultCheckbox,
    setVideoConsultCheckbox,
  } = props;

  const [videoStartTimeArray, setVideoStartTimeArray] = useState([
    {
      timeSlotId: 1,
      time: "",
    },
  ]);

  const [videoEndTimeArray, setVideoEndTimeArray] = useState([
    {
      timeSlotId: 1,
      time: "",
    },
  ]);

  const [clinicStartTimeArray, setClinicStartTimeArray] = useState([
    {
      timeSlotId: 1,
      time: "",
    },
  ]);

  const [clinicEndTimeArray, setClinicEndTimeArray] = useState([
    {
      timeSlotId: 1,
      time: "",
    },
  ]);

  useEffect(() => {
    const durations = [
      { label: 10, id: 10 },
      { label: 20, id: 20 },
      { label: 30, id: 30 },
      { label: 40, id: 40 },
      { label: 50, id: 50 },
      { label: 60, id: 60 },
    ];
    setConsultationMinutes(durations);
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const response = await APIV3.get(`doctor/all-clinic-listing`);

        if (response?.status == 200) {
          setClinics(response?.data?.data);
        }
      } catch (error) {}
    })();
  }, []);

  const handleConsultCheckbox = () => {
    setVideoConsultCheckbox(!videoConsultCheckbox);
  };

  const handleClinicCheckbox = () => {
    setVideoClinicCheckbox(!videoClinicCheckbox);
  };

  //For Video Clinics state and add/manipulate functions...
  // function addVideoSlot(e, clinicId) {

  //   setVideoSlots([
  //     ...videoSlots,
  //     {
  //       clinicId: clinicId,
  //       slotsId: videoSlots.length + 1,
  //     },
  //   ]);
  // }

  function addVideoSlot(e, clinicId) {
    e.preventDefault();

    // const newSlotId = videoSlots.length + 1;
    const newSlotId = Math.random().toString(36).substr(2, 9);

    const allDays = [
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "sunday",
    ];

    const usedDays = videoTimeSlots.map((slot) => slot.day);
    const firstAvailableDay = allDays.find((day) => !usedDays.includes(day));

    if (!firstAvailableDay) {
      // message.warning("All days are already selected.");
      console.log("All days are already selected.");
      return;
    }

    // Update UI slots
    setVideoSlots((prev) => [
      ...prev,
      {
        clinicId: clinicId,
        slotsId: newSlotId,
      },
    ]);

    setVideoTimeSlots((prev) => [
      ...prev,
      {
        clinicId: clinicId,
        slotsId: newSlotId,
        day: firstAvailableDay,
        timeSlotId: Math.random().toString(36).substr(2, 9),
        from: "",
        to: "",
      },
    ]);

    // ✅ Set the value into the AntD Form manually so Radio shows as selected
    form.setFieldsValue({
      [`video_day${newSlotId}`]: firstAvailableDay,
    });
  }

  useEffect(() => {
    console.log("Current videoTimeSlots:", videoTimeSlots);
  }, [videoTimeSlots]);

  // function deleteVideoSlot(e, slotId) {
  //   const slots = videoSlots?.filter((item) => {
  //     return item?.slotsId !== slotId;
  //   });

  //   setVideoSlots(slots);
  // }
  function deleteVideoSlot(e, slotId) {
    setVideoSlots((prev) => prev.filter((item) => item?.slotsId !== slotId));
    setVideoTimeSlots((prev) =>
      prev.filter((item) => item?.slotsId !== slotId)
    );
  }

  function addVideoTimeSlot(e, clinicId, slotId) {
    // Try to find the first matching slot with same clinicId and slotId
    const existingSlot = videoTimeSlots?.find(
      (slot) => slot.clinicId === clinicId && slot.slotsId === slotId
    );

    // Use the same day if available, otherwise default to empty string or 'monday'
    const dayToAssign = existingSlot?.day || "";

    // ✅ Generate a globally unique timeSlotId
    const existingIds = videoTimeSlots.map((slot) => slot.timeSlotId);
    // let uniqueId = 1;
    // while (existingIds.includes(uniqueId)) {
    //   uniqueId++;
    // }
    const uniqueId = Math.random().toString(36).substr(2, 9);

    setVideoTimeSlots((prev) => [
      ...prev,
      {
        clinicId: clinicId,
        slotsId: slotId,
        timeSlotId: uniqueId,
        day: dayToAssign,
      },
    ]);
  }

  // function deleteVideoTimeSlot(e, slotId, timeSlotId) {
  //   const updatedSlots = videoTimeSlots?.filter(
  //     (item) => item?.timeSlotId !== timeSlotId
  //   );
  //   setVideoTimeSlots(updatedSlots);

  //   // Clear the related form fields when deleting a time slot
  //   if (props.form) {
  //     props.form.setFieldsValue({
  //       [`video_starttime${timeSlotId}`]: null,
  //       [`video_starttimemin${timeSlotId}`]: null,
  //       [`video_endtime${timeSlotId}`]: null,
  //       [`video_endtimemin${timeSlotId}`]: null,
  //     });
  //   }
  // }
  function deleteVideoTimeSlot(e, slotId, timeSlotId) {
  e.preventDefault();

  // Prevent deleting the last slot under same slotsId
  const filteredSlots = videoTimeSlots.filter((item) => item.slotsId === slotId);
  if (filteredSlots.length <= 1) {
    return; // Do not delete if it's the only slot for that day
  }

  // Remove from videoTimeSlots
  const updatedSlots = videoTimeSlots.filter(
    (item) => item.timeSlotId !== timeSlotId
  );
  setVideoTimeSlots(updatedSlots);

  // Remove from video start and end arrays if you have them (optional)
  setVideoStartTimeArray((prev) =>
    prev.filter((item) => item.timeSlotId !== timeSlotId)
  );
  setVideoEndTimeArray((prev) =>
    prev.filter((item) => item.timeSlotId !== timeSlotId)
  );

  // Clear form values
  if (props.form) {
    props.form.setFieldsValue({
      [`video_starttime${timeSlotId}`]: null,
      [`video_starttimemin${timeSlotId}`]: null,
      [`video_endtime${timeSlotId}`]: null,
      [`video_endtimemin${timeSlotId}`]: null,
    });
  }
}


  function setLocalVideoSlots(checked, day, clinicId, slotId) {
    if (checked) {
      // Prevent adding slot if same day already exists
      // const dayExists = videoTimeSlots?.some((slot) => slot.day === day);
      const dayExists = videoTimeSlots?.some(
        (slot) => slot.day === day && slot.slotsId !== slotId
      );

      if (dayExists) {
        return;
      }

      // ✅ Reset all form fields for this slotId (based on timeSlotId)
      videoTimeSlots
        .filter((slot) => slot.slotsId == slotId)
        .forEach((slot) => {
          props.form.setFieldsValue({
            [`video_starttime${slot.timeSlotId}`]: null,
            [`video_starttimemin${slot.timeSlotId}`]: null,
            [`video_endtime${slot.timeSlotId}`]: null,
            [`video_endtimemin${slot.timeSlotId}`]: null,
          });
        });

      // ✅ Remove ALL timeSlots with this slotId (regardless of day)
      const filtered = videoTimeSlots.filter((slot) => slot.slotsId !== slotId);

      setVideoTimeSlots([
        ...filtered,
        {
          clinicId: clinicId,
          slotsId: slotId,
          timeSlotId: videoTimeSlots.length + 1,
          day: day,
        },
      ]);
    } else if (!checked) {
      // Not used in radio, but kept for integrity
      const slots = videoTimeSlots?.filter((slot) => {
        return slot?.slotsId !== slotId || slot?.day !== day;
      });

      setVideoTimeSlots(slots);
    }
  }

  // For clinic visit state and manipulation functions

  function addClinicSlot(e, clinicId) {
    e.preventDefault();

    const newSlotId = clinicSlots.length + 1;

    const allDays = [
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "sunday",
    ];

    const usedDays = clinicTimeSlots.map((slot) => slot.day);
    const firstAvailableDay = allDays.find((day) => !usedDays.includes(day));

    if (!firstAvailableDay) {
      console.log("All days are already selected.");
      return;
    }

    // Update UI slots
    setClinicSlots((prev) => [
      ...prev,
      {
        clinicId: clinicId,
        slotsId: newSlotId,
      },
    ]);

    // Add to clinicTimeSlots state
    setClinicTimeSlots((prev) => [
      ...prev,
      {
        clinicId: clinicId,
        slotsId: newSlotId,
        day: firstAvailableDay,
        timeSlotId: Math.random().toString(36).substr(2, 9),
        from: "",
        to: "",
      },
    ]);

    // ✅ Set the selected day into the AntD form manually
    form.setFieldsValue({
      [`clinic_day${newSlotId}`]: firstAvailableDay,
    });
  }

  // function addClinicSlot(e, clinicId) {
  //   setClinicSlots([
  //     ...clinicSlots,
  //     {
  //       clinicId: clinicId,
  //       slotsId: clinicSlots.length + 1,
  //     },
  //   ]);
  // }

  function deleteClinicSlot(e, slotId) {
    const slots = clinicSlots?.filter((item) => {
      return item?.slotsId !== slotId;
    });

    setClinicSlots(slots);
  }

  function addClinicTimeSlot(e, clinicId, slotId) {
    // Try to find the first matching slot with same clinicId and slotId
    const existingSlot = clinicTimeSlots.find(
      (slot) => slot.clinicId === clinicId && slot.slotsId === slotId
    );

    // Use the same day if available, otherwise default to empty string or 'monday'
    const dayToAssign = existingSlot?.day || "";

    // ✅ Generate a globally unique timeSlotId
    const existingIds = clinicTimeSlots.map((slot) => slot.timeSlotId);
    let uniqueId = 1;
    while (existingIds.includes(uniqueId)) {
      uniqueId++;
    }

    setClinicTimeSlots((prev) => [
      ...prev,
      {
        clinicId: clinicId,
        slotsId: slotId,
        timeSlotId: uniqueId,
        day: dayToAssign,
      },
    ]);
  }

  // function deleteClinicTimeSlot(e, clinicId, timeSlotId) {
  //   const updatedSlots = clinicTimeSlots?.filter(
  //     (item) => item?.timeSlotId !== timeSlotId
  //   );
  //   setClinicTimeSlots(updatedSlots);

  //   if (props.form) {
  //     props.form.setFieldsValue({
  //       [`visit_start_time${timeSlotId}`]: null,
  //       [`visit_start_timeMin${timeSlotId}`]: null,
  //       [`visit_end_time${timeSlotId}`]: null,
  //       [`visit_end_timemin${timeSlotId}`]: null,
  //     });
  //   }
  // }

  function deleteClinicTimeSlot(e, clinicId, timeSlotId) {
    e.preventDefault();

    // Remove from clinicTimeSlots
    const updatedSlots = clinicTimeSlots?.filter(
      (item) => item?.timeSlotId !== timeSlotId
    );
    setClinicTimeSlots(updatedSlots);

    // Remove from start time array
    setClinicStartTimeArray((prev) =>
      prev.filter((item) => item.timeSlotId !== timeSlotId)
    );

    // Remove from end time array
    setClinicEndTimeArray((prev) =>
      prev.filter((item) => item.timeSlotId !== timeSlotId)
    );

    // Clear form values
    if (props.form) {
      props.form.setFieldsValue({
        [`visit_start_time${timeSlotId}`]: null,
        [`visit_start_timeMin${timeSlotId}`]: null,
        [`visit_end_time${timeSlotId}`]: null,
        [`visit_end_timemin${timeSlotId}`]: null,
      });
    }
  }

  function setLocalClinicSlots(checked, day, clinicId, slotId) {
    if (checked) {
      // Remove previous day (if any) for this slot

      const dayExists = clinicTimeSlots?.some((slot) => slot.day === day);
      if (dayExists) {
        return;
      }

      // ✅ Reset all form fields for this slotId (based on timeSlotId)
      clinicTimeSlots
        .filter((slot) => slot.slotsId == slotId)
        .forEach((slot) => {
          props.form.setFieldsValue({
            [`visit_start_time${slot.timeSlotId}`]: null,
            [`visit_start_timeMin${slot.timeSlotId}`]: null,
            [`visit_end_time${slot.timeSlotId}`]: null,
            [`visit_end_timemin${slot.timeSlotId}`]: null,
          });
        });

      // ✅ Remove ALL timeSlots with this slotId (regardless of day)
      const filtered = clinicTimeSlots.filter(
        (slot) => slot.slotsId !== slotId
      );

      setClinicTimeSlots([
        ...filtered,
        {
          clinicId: clinicId,
          slotsId: slotId,
          timeSlotId: clinicTimeSlots.length + 1,
          day: day,
        },
      ]);
    } else if (!checked) {
      // Not used in radio, but kept for integrity
      const slots = clinicTimeSlots?.filter((slot) => {
        return slot?.slotsId !== slotId || slot?.day !== day;
      });
      setClinicTimeSlots(slots);
    }
  }

  const validateLocationNumber = (_, value) => {
    const alphanumericRegex = /^[a-zA-Z0-9\s]*[a-zA-Z0-9][a-zA-Z0-9\s]*$/; // Regular expression to allow alphanumeric characters and spaces, with at least one alphanumeric character

    // if (!value) {
    //   setRedField(true);
    //   return Promise.reject("Location is required");
    // }

    const isAlphanumeric = alphanumericRegex.test(value);

    // if (isAlphanumeric == '') {
    //   return Promise.reject("Location is required");
    //   setRedField(true)

    // }

    if (!isAlphanumeric) {
      return Promise.reject("Location should be alphanumeric");
    }

    return Promise.resolve();
  };

  const validateLocationRequired = (_, value) => {
    if (!value) {
      return Promise.reject("Location is required");
    } else {
      return Promise.resolve();
    }
  };

  function handleVideoStartTimeChange(e, timeSlotId) {
    setVideoStartTimeArray((prev) => {
      // Remove any previous entry for this timeSlotId
      const filtered = prev.filter((item) => item.timeSlotId !== timeSlotId);
      return [
        ...filtered,
        {
          timeSlotId,
          time: e,
        },
      ];
    });
  }

  console.log({ videoStartTimeArray });

  function handleVideoEndTimeChange(e, timeSlotId) {
    setVideoEndTimeArray((prev) => {
      // Remove any previous entry for this timeSlotId
      const filtered = prev.filter((item) => item.timeSlotId !== timeSlotId);
      return [
        ...filtered,
        {
          timeSlotId,
          time: e,
        },
      ];
    });
  }

  const validateVideoEndTime = (id) => (rule, value) => {
    const startTime = videoStartTimeArray.find(
      (item) => item?.timeSlotId === id
    );
    if (
      value &&
      startTime &&
      (value.isSame(startTime.time, "minute") ||
        value.isBefore(startTime.time, "minute"))
    ) {
      return Promise.reject("End time must be greater than start time");
    }

    // Find the day for this slot
    const slotDay = videoTimeSlots?.find((slot) => slot.timeSlotId === id)?.day;

    if (!slotDay) return Promise.resolve();

    // Get all slots for this day except current
    const slotsForDay = videoTimeSlots?.filter(
      (slot) => slot.day === slotDay && slot.timeSlotId !== id
    );

    // Check for overlap with other slots on the same day
    for (let slot of slotsForDay) {
      const start = videoStartTimeArray?.find(
        (s) => s.timeSlotId === slot.timeSlotId
      )?.time;
      const end = videoEndTimeArray?.find(
        (s) => s.timeSlotId === slot.timeSlotId
      )?.time;
      if (start && end && value?.isBetween(start, end, "minute", "[]")) {
        return Promise.reject(
          "End time overlaps with another slot on this day"
        );
      }
    }

    return Promise.resolve();
  };

  const validateVideoStartTime = (id) => (_rule, value) => {
    // Find the current slot's day
    const slotDay = videoTimeSlots?.find((slot) => slot.timeSlotId === id)?.day;
    if (!slotDay) return Promise.resolve();

    // Get all slots for this day, sorted by start time
    const slotsForDay = videoTimeSlots
      ?.filter((slot) => slot.day === slotDay)
      ?.map((slot) => ({
        ...slot,
        start: videoStartTimeArray?.find(
          (s) => s.timeSlotId === slot.timeSlotId
        )?.time,
        end: videoEndTimeArray?.find((s) => s.timeSlotId === slot.timeSlotId)
          ?.time,
      }))
      ?.sort((a, b) => {
        if (!a.start || !b.start) return 0;
        return a.start.isBefore(b.start) ? -1 : 1;
      });

    // Check for duplicate start time across slots on the same day
    const duplicateSlot = slotsForDay.find(
      (slot) =>
        slot.timeSlotId !== id &&
        slot.start &&
        value &&
        value.isSame(slot.start, "minute")
    );
    if (duplicateSlot) {
      return Promise.reject("Start time is already selected in another slot");
    }

    // Find the current slot's index in the sorted array
    const currentIndex = slotsForDay?.findIndex(
      (slot) => slot.timeSlotId === id
    );

    // If not the first slot, ensure start time is strictly after the previous slot's end time
    if (currentIndex > 0 && value) {
      const prevSlot = slotsForDay[currentIndex - 1];
      if (
        prevSlot.end &&
        (value.isSame(prevSlot.end, "minute") ||
          value.isSameOrBefore(prevSlot.end, "minute"))
      ) {
        return Promise.reject(
          "Start time must be after previous slot's end time"
        );
      }
    }

    return Promise.resolve();
  };
  function handleClinicStartTimeChange(e, timeSlotId) {
    console.log("Selected raw time:", e); // moment object
    console.log("Formatted time (h:mm A):", e?.format("h:mm A"));
    console.log("Formatted hour only (h A):", e?.format("h A"));
    console.log("24-hour format:", e?.format("HH:mm"));

    setClinicStartTimeArray((prev) => {
      const filtered = prev?.filter((item) => item.timeSlotId !== timeSlotId);
      return [
        ...filtered,
        {
          timeSlotId,
          time: e,
        },
      ];
    });
  }

  function handleClinicEndTimeChange(e, timeSlotId) {
    setClinicEndTimeArray((prev) => {
      // Remove any previous entry for this timeSlotId
      const filtered = prev?.filter((item) => item.timeSlotId !== timeSlotId);
      return [
        ...filtered,
        {
          timeSlotId,
          time: e,
        },
      ];
    });
  }

  const validateClinicEndTime = (id) => (rule, value) => {
    const startTime = clinicStartTimeArray.find(
      (item) => item?.timeSlotId === id
    );

    if (
      value &&
      startTime &&
      (value.isSame(startTime.time, "minute") ||
        value.isBefore(startTime.time, "minute"))
    ) {
      return Promise.reject("End time must be greater than start time");
    }

    // Find the day for this slot
    const slotDay = clinicTimeSlots?.find(
      (slot) => slot.timeSlotId === id
    )?.day;

    if (!slotDay) return Promise.resolve();

    // Get all slots for this day except current
    const slotsForDay = clinicTimeSlots?.filter(
      (slot) => slot.day === slotDay && slot.timeSlotId !== id
    );

    // Get start/end times for all other slots on this day
    for (let slot of slotsForDay) {
      const start = clinicStartTimeArray?.find(
        (s) => s.timeSlotId === slot.timeSlotId
      )?.time;
      const end = clinicEndTimeArray?.find(
        (s) => s.timeSlotId === slot.timeSlotId
      )?.time;
      if (start && end && value?.isBetween(start, end, "minute", "[]")) {
        return Promise.reject(
          "End time overlaps with another slot on this day"
        );
      }
    }

    return Promise.resolve();
  };

  const validateClinicStartTime = (id) => (_rule, value) => {
    // Find the current slot's day
    const slotDay = clinicTimeSlots?.find(
      (slot) => slot.timeSlotId === id
    )?.day;
    if (!slotDay) return Promise.resolve();

    // Get all slots for this day, sorted by start time
    const slotsForDay = clinicTimeSlots
      ?.filter((slot) => slot.day === slotDay)
      ?.map((slot) => ({
        ...slot,
        start: clinicStartTimeArray?.find(
          (s) => s.timeSlotId === slot.timeSlotId
        )?.time,
        end: clinicEndTimeArray?.find((s) => s.timeSlotId === slot.timeSlotId)
          ?.time,
      }))
      ?.sort((a, b) => {
        if (!a.start || !b.start) return 0;
        return a.start.isBefore(b.start) ? -1 : 1;
      });

    // Check for duplicate start time across slots on the same day
    const duplicateSlot = slotsForDay.find(
      (slot) =>
        slot.timeSlotId !== id &&
        slot.start &&
        value &&
        value.isSame(slot.start, "minute")
    );
    if (duplicateSlot) {
      return Promise.reject("Start time is already selected in another slot");
    }

    // Find the current slot's index in sorted array
    const currentIndex = slotsForDay?.findIndex(
      (slot) => slot.timeSlotId === id
    );

    // If not the first slot, check previous slot's end time
    if (currentIndex > 0 && value) {
      const prevSlot = slotsForDay[currentIndex - 1];
      if (
        prevSlot.end &&
        (value.isSame(prevSlot.end, "minute") ||
          value.isSameOrBefore(prevSlot.end, "minute"))
      ) {
        return Promise.reject(
          "Start time must be after previous slot's end time"
        );
      }
    }

    return Promise.resolve();
  };

  function generateArrayWithoutNumber() {
    let res = [];
    for (let i = 0; i <= 255; i++) {
      if (i >= 48 && i <= 57) {
      } else {
        res.push(String.fromCharCode(i));
      }
    }
    return res;
  }

  const arrayWithoutNumber = useMemo(() => generateArrayWithoutNumber(), []);
  const [form] = Form.useForm();

  return (
    <StyledVideoConsultation>
      <Row>
        <Col
          lg={6}
          md={6}
          className="checkbox_style consultation_checkbox scrollable"
          style={{ height: !isMobile ? "700px" : "" }}
        >
          <div className="mb-24">
            <Checkbox
              checked={videoConsultCheckbox}
              onChange={handleConsultCheckbox}
            >
              {" "}
              <span className="video">Video Consult</span>{" "}
              {/* <span className="consult_p">
                Consult patients online through video calls.{" "}
              </span> */}
            </Checkbox>
          </div>
          {videoConsultCheckbox && (
            <div className="video_consult ">
              <Row className="">
                <Col md={6} lg={6} className="selectBox sss">
                  <Form.Item
                    name={`video_mins`}
                    label={"Duration"}
                    rules={[
                      {
                        required: true,
                        message: "Consultation duration is required",
                      },
                    ]}
                  >
                    <Select
                      onChange={(value) => {
                        setMins(value);
                      }}
                      placeholder="Select"
                    >
                      {consultationMinutes?.length > 0 &&
                        consultationMinutes?.map((item) => (
                          <>
                            <Option value={item?.id}>{item?.label} mins</Option>
                          </>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col md={6} lg={6} className="selectBox ">
                  <Form.Item
                    name={`video_fee`}
                    label="Consultation Fee* "
                    rules={[
                      {
                        required: true,
                        message: "Consultation fee is required",
                      },
                    ]}
                  >
                    <Input
                      onKeyDown={(evt) =>
                        arrayWithoutNumber.includes(evt.key) &&
                        evt.preventDefault()
                      }
                      maxLength={5}
                      onChange={(e) => {
                        setFees(e.target.value);
                      }}
                      value={fees}
                      placeholder="Enter fee"
                    />
                  </Form.Item>
                </Col>
                <Col md={12} lg={12} className=" position-relative">
                  {videoSlots?.map((slot, index) => (
                    <Row key={index} className="duplicate_row_days">
                      <Col lg={12}>
                        {index === 0 ? (
                          /* Render content for the first row */
                          <Col lg={12} md={12} className="text-end ">
                            <Row>
                              <Col lg={12} md={12} className="mx-auto">
                                <hr />
                              </Col>
                            </Row>
                            {/* Your content for the first row */}
                          </Col>
                        ) : (
                          /* Render content for other rows */
                          <Col lg={12} md={12} className="text-end ">
                            <Row>
                              <Col lg={12} md={12} className="mx-auto">
                                <hr />
                              </Col>
                            </Row>

                            <button className="last">
                              <img
                                src={deleteIcon}
                                alt="Delete"
                                onClick={(e) =>
                                  deleteVideoSlot(e, slot?.slotsId)
                                }
                                className="img-fluid"
                              />
                            </button>
                          </Col>
                        )}
                      </Col>
                      <Col md={12} lg={12} className="aa">
                        {index === 0 && (
                          <div className="addDays mb-3">
                            <Button
                              className="btn btn_add "
                              onClick={(e) => addVideoSlot(e, 1)}
                            >
                              <img src={plusIcon} alt="Add" /> Add Days
                            </Button>
                          </div>
                        )}
                        <Form.Item
                          name={`video_day${slot?.slotsId}`}
                          label="Consultation Days"
                          type="array"
                          rules={[
                            {
                              validator: (_, value) => {
                                if (!value || value.length === 0) {
                                  return Promise.reject(
                                    "At least one consultation day is required"
                                  );
                                }
                                return Promise.resolve();
                              },
                            },
                          ]}
                        >
                          <Radio.Group
                            className={`radio_blue  ${
                              isMobile ? "scrollable days-container" : ""
                            }`}
                            onChange={(e) => {
                              const selectedDay = e.target.value;
                              const dayExists = videoTimeSlots.some(
                                (slot) =>
                                  slot.day === selectedDay &&
                                  slot.slotsId !== slot?.slotsId
                              );
                              if (dayExists) {
                                // console.warn(`Day "${selectedDay}" already selected. Skipping.`);
                                return;
                              }

                              setLocalVideoSlots(
                                true,
                                selectedDay,
                                1,
                                slot?.slotsId
                              );
                            }}
                            value={
                              videoTimeSlots.find(
                                (s) => s.slotsId === slot?.slotsId
                              )?.day || null
                            }
                          >
                            {[
                              "monday",
                              "tuesday",
                              "wednesday",
                              "thursday",
                              "friday",
                              "saturday",
                              "sunday",
                            ]?.map((day) => (
                              <Radio.Button
                                key={day}
                                value={day}
                                disabled={videoTimeSlots.some(
                                  (slotItem) =>
                                    slotItem.day === day &&
                                    slotItem.slotsId !== slot?.slotsId
                                )}
                              >
                                <div className="days">
                                  {!isMobile
                                    ? day.slice(0, 3).charAt(0).toUpperCase() +
                                      day.slice(1, 3)
                                    : day.slice(0, 3)}
                                </div>
                              </Radio.Button>
                            ))}
                          </Radio.Group>
                        </Form.Item>
                      </Col>
                      <div className="position-relative">
                        <Col md={12} lg={12} className="">
                          {videoTimeSlots?.map((item, index1) => {
                            if (
                              item?.slotsId === slot?.slotsId &&
                              item?.clinicId === 1
                            ) {
                              return (
                                <>
                                  <Row
                                    key={index1}
                                    className={`duplicate_row_time ${
                                      isMobile ? "flex-column" : ""
                                    }`}
                                  >
                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={6}
                                      className="selectBox "
                                    >
                                      <div className="d-flex justify-content-between dltbtnSet">
                                        <label>Start Time*</label>
                                        {isMobile && index1 !== 0 && (
                                          <button className="last buttonSetTime">
                                            <img
                                              src={deleteIcon}
                                              alt="Delete"
                                              onClick={(e) => {
                                                deleteVideoTimeSlot(
                                                  e,
                                                  slot?.slotsId,
                                                  videoTimeSlots?.length
                                                );
                                                // deleteVideoSlot(e, slot?.slotsId)
                                              }}
                                              className="img-fluid"
                                            />
                                          </button>
                                        )}
                                      </div>
                                      <Row
                                        className={`${
                                          isMobile ? "flex-row" : ""
                                        }`}
                                      >
                                        <Col lg={6} xs={6}>
                                          <Form.Item
                                            name={`video_starttime${item?.timeSlotId}`}
                                            rules={[
                                              {
                                                required: true,
                                                message:
                                                  "Start time is required",
                                              },
                                              {
                                                validator:
                                                  validateVideoStartTime(
                                                    item?.timeSlotId
                                                  ),
                                              },
                                            ]}
                                          >
                                            <TimePicker
                                              className="custom-timepicker text-center"
                                              use12Hours
                                              format="h A"
                                              minuteStep={60} // Only shows 00 minutes
                                              hideDisabledOptions
                                              placeholder="Hour"
                                              onChange={(e) =>
                                                handleVideoStartTimeChange(
                                                  e,
                                                  item?.timeSlotId
                                                )
                                              }
                                              inputReadOnly={true}
                                            />
                                          </Form.Item>
                                        </Col>
                                        <Col lg={6} xs={6}>
                                          <Form.Item
                                            name={`video_starttimemin${item?.timeSlotId}`}
                                            rules={[
                                              {
                                                required: true,
                                                message:
                                                  "Start time is required",
                                              },
                                            ]}
                                          >
                                            <TimePicker
                                              className="custom-timepicker text-center"
                                              format="mm"
                                              placeholder="Minutes"
                                              inputReadOnly={true}
                                            />
                                          </Form.Item>
                                        </Col>
                                      </Row>
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={6}
                                      className="selectBox"
                                    >
                                      <div className="d-flex justify-content-between dltbtnSet">
                                        <label>End Time*</label>
                                        {videoTimeSlots.filter(
                                          (s) => s.slotsId === slot?.slotsId
                                        ).length > 1 && (
                                          <button
                                            type="button"
                                            className="last buttonSetTime"
                                            onClick={(e) =>
                                              deleteVideoTimeSlot(
                                                e,
                                                slot?.slotsId,
                                                item?.timeSlotId
                                              )
                                            }
                                          >
                                            <img
                                              src={deleteIcon}
                                              alt="Delete"
                                              className="img-fluid"
                                            />
                                          </button>
                                        )}
                                      </div>
                                      <Row>
                                        <Col lg={6} xs={6}>
                                          <Form.Item
                                            name={`video_endtime${item?.timeSlotId}`}
                                            label=""
                                            rules={[
                                              {
                                                required: true,
                                                message: "End time is required",
                                              },
                                              {
                                                validator: validateVideoEndTime(
                                                  item?.timeSlotId
                                                ),
                                              },
                                            ]}
                                          >
                                            <TimePicker
                                              className="custom-timepicker text-center"
                                              use12Hours
                                              format="h A"
                                              minuteStep={60}
                                              hideDisabledOptions
                                              placeholder="Hour"
                                              onChange={(e) =>
                                                handleVideoEndTimeChange(
                                                  e,
                                                  item?.timeSlotId
                                                )
                                              }
                                              inputReadOnly={true}
                                            />
                                          </Form.Item>
                                        </Col>
                                        <Col lg={6} xs={6}>
                                          <Form.Item
                                            name={`video_endtimemin${item?.timeSlotId}`}
                                            rules={[
                                              {
                                                required: true,
                                                message: "End time is required",
                                              },
                                            ]}
                                          >
                                            <TimePicker
                                              className="custom-timepicker text-center"
                                              format="mm"
                                              placeholder="Minutes"
                                              inputReadOnly={true}
                                            />
                                          </Form.Item>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                </>
                              );
                            }
                          })}

                          {/* {isBrowser ? ( */}
                          <Col md={12} lg={12} className="">
                            <div className="add_moretime text-end">
                              <Button
                                className="btn btn_add"
                                onClick={(e) =>
                                  addVideoTimeSlot(e, 1, slot?.slotsId)
                                }
                              >
                                <img src={plusIcon} alt="Add" /> Add Slots
                              </Button>
                            </div>
                          </Col>
                        </Col>
                      </div>
                    </Row>
                  ))}
                </Col>
              </Row>
              {/* lklk */}
            </div>
          )}
        </Col>

        {/* After line 386, copy from random.js... */}
        <Col
          lg={6}
          md={6}
          className="checkbox_style consultation_checkbox scrollable hk_clinic_physical"
          style={{ height: !isMobile ? "700px" : "" }}
        >
          <div className="mb-24">
            <Checkbox
              checked={videoClinicCheckbox}
              onChange={handleClinicCheckbox}
            >
              {" "}
              <span className="video">Clinic Visit</span>{" "}
              {/* <span className="consult_p">
              Consult patients in-person at your clinic.{" "}
            </span> */}
            </Checkbox>
          </div>

          {videoClinicCheckbox && (
            <div className="video_consult ">
              <Row className="">
                <Col
                  lg={12}
                  md={12}
                  className="checkbox_style consultation_checkbox"
                >
                  <div
                    className={!isMobile ? "video_consult" : "video_consult"}
                  >
                    <Row className="">
                      <Col md={12} lg={12} className="position-relative">
                        {clinicVisit?.map((row, index) =>
                          !isMobile ? (
                            <Row key={row?.id} className="duplicate_row_days">
                              <Col
                                md={12}
                                lg={12}
                                className="selectBox clinicB0x"
                              >
                                <Form.Item
                                  name={`visit_clinic_id`}
                                  label="Clinic/Hospital* "
                                  rules={[
                                    {
                                      required: true,
                                      message: "Clinic/Hospital is required",
                                    },
                                  ]}
                                >
                                  <Select
                                    showSearch
                                    filterOption={(input, option) =>
                                      option.props.children
                                        .toLowerCase()
                                        .startsWith(input.toLowerCase())
                                    }
                                    onChange={(value) => {
                                      setHospital(value);
                                    }}
                                    placeholder="Select"
                                  >
                                    {clinics.map((option) => (
                                      <Option
                                        key={option?.value}
                                        value={option?.id}
                                      >
                                        {option?.name}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </Col>
                              <Col md={6} lg={6} className="selectBox ">
                                <Form.Item
                                  name={`clinic_visit_mins`}
                                  label="Duration "
                                  rules={[
                                    {
                                      required: true,
                                      message:
                                        "Consultation duration is required",
                                    },
                                  ]}
                                >
                                  <Select placeholder="Please select">
                                    {consultationMinutes?.length > 0 &&
                                      consultationMinutes?.map((item) => (
                                        <>
                                          <Option value={item?.id}>
                                            {item?.label} mins
                                          </Option>
                                        </>
                                      ))}
                                  </Select>
                                </Form.Item>
                              </Col>
                              <Col md={6} lg={6} className="selectBox ">
                                <Form.Item
                                  name={`visit_consultation_fee`}
                                  label="Consultation Fee*"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Consultation fee is required",
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder="Enter fee"
                                    maxLength={5}
                                    onKeyDown={(evt) =>
                                      arrayWithoutNumber.includes(evt.key) &&
                                      evt.preventDefault()
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              {clinicSlots.map((slot, index) => (
                                <Row key={index} className="duplicate_row_days">
                                  <Col lg={12}>
                                    {index === 0 ? (
                                      /* Render content for the first row */
                                      <Col
                                        lg={12}
                                        md={12}
                                        className="text-end "
                                      >
                                        <Row>
                                          <Col
                                            lg={12}
                                            md={12}
                                            className="mx-auto"
                                          >
                                            <hr />
                                          </Col>
                                        </Row>
                                        {/* Your content for the first row */}
                                      </Col>
                                    ) : (
                                      /* Render content for other rows */
                                      <Col
                                        lg={12}
                                        md={12}
                                        className="text-end "
                                      >
                                        <Row>
                                          <Col
                                            lg={12}
                                            md={12}
                                            className="mx-auto"
                                          >
                                            <hr />
                                          </Col>
                                        </Row>

                                        <button className="last">
                                          <img
                                            src={deleteIcon}
                                            alt="Delete"
                                            onClick={(e) =>
                                              deleteClinicSlot(e, slot?.slotsId)
                                            }
                                            className="img-fluid"
                                          />
                                        </button>
                                      </Col>
                                    )}
                                  </Col>
                                  <Col md={12} lg={12} className="aa">
                                    {index === 0 && (
                                      <div className="addDays mb-3">
                                        <Button
                                          className="btn btn_add "
                                          onClick={(e) => addClinicSlot(e, 1)}
                                        >
                                          <img src={plusIcon} alt="Add" /> Add
                                          Days
                                        </Button>
                                      </div>
                                    )}
                                    <Form.Item
                                      name={`visit-day${slot?.slotsId}`}
                                      label="Consultation Days "
                                      type="array"
                                      rules={[
                                        {
                                          validator: (_, value) => {
                                            if (!value || value.length === 0) {
                                              return Promise.reject(
                                                "At least one consultation day is required"
                                              );
                                            }
                                            return Promise.resolve();
                                          },
                                        },
                                      ]}
                                    >
                                      <Radio.Group
                                        className={`radio_blue ${
                                          isMobile
                                            ? "scrollable days-container"
                                            : ""
                                        }`}
                                        onChange={(e) => {
                                          const selectedDay = e.target.value;

                                          // ✅ Check if the selected day already exists for a different slotId
                                          const dayExists =
                                            clinicTimeSlots.some(
                                              (slotItem) =>
                                                slotItem.day === selectedDay &&
                                                slotItem.slotsId !==
                                                  slot?.slotsId
                                            );

                                          if (dayExists) {
                                            // Prevent selection if day is already assigned elsewhere
                                            return;
                                          }

                                          setLocalClinicSlots(
                                            true,
                                            selectedDay,
                                            1,
                                            slot?.slotsId
                                          );
                                        }}
                                        value={
                                          clinicTimeSlots.find(
                                            (s) => s.slotsId === slot?.slotsId
                                          )?.day || null
                                        }
                                      >
                                        {[
                                          "monday",
                                          "tuesday",
                                          "wednesday",
                                          "thursday",
                                          "friday",
                                          "saturday",
                                          "sunday",
                                        ].map((day) => (
                                          <Radio.Button
                                            key={day}
                                            value={day}
                                            disabled={clinicTimeSlots.some(
                                              (slotItem) =>
                                                slotItem.day === day &&
                                                slotItem.slotsId !==
                                                  slot?.slotsId
                                            )}
                                          >
                                            <div className="days">
                                              {!isMobile
                                                ? day
                                                    .slice(0, 3)
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                  day.slice(1, 3)
                                                : day.slice(0, 3)}
                                            </div>
                                          </Radio.Button>
                                        ))}
                                      </Radio.Group>
                                    </Form.Item>
                                  </Col>
                                  <div className="position-relative">
                                    <Col md={12} lg={12} className="">
                                      {clinicTimeSlots?.map((item, index1) => {
                                        if (
                                          item?.slotsId === slot?.slotsId &&
                                          item?.clinicId === 1
                                        ) {
                                          return (
                                            <>
                                              <Row
                                                key={index1}
                                                className={`duplicate_row_time ${
                                                  isMobile ? "flex-column" : ""
                                                }`}
                                              >
                                                <Col
                                                  xs={12}
                                                  md={6}
                                                  lg={6}
                                                  className="selectBox "
                                                >
                                                  <div className="d-flex justify-content-between dltbtnSet">
                                                    <label>Start Time*</label>
                                                    {isMobile &&
                                                      index1 !== 0 && (
                                                        <button
                                                          type="button"
                                                          className="last buttonSetTime"
                                                        >
                                                          <img
                                                            src={deleteIcon}
                                                            alt="Delete"
                                                            onClick={(e) => {
                                                              deleteClinicTimeSlot(
                                                                e,
                                                                slot?.slotsId,
                                                                clinicTimeSlots?.length
                                                              );
                                                              // deleteVideoSlot(e, slot?.slotsId)
                                                            }}
                                                            className="img-fluid"
                                                          />
                                                        </button>
                                                      )}
                                                  </div>

                                                  <Row
                                                    className={`${
                                                      isMobile ? "flex-row" : ""
                                                    }`}
                                                  >
                                                    <Col lg={6} xs={6}>
                                                      <Form.Item
                                                        name={`visit_start_time${item?.timeSlotId}`}
                                                        rules={[
                                                          {
                                                            required: true,
                                                            message:
                                                              "Start time is required",
                                                          },
                                                          {
                                                            validator:
                                                              validateClinicStartTime(
                                                                item?.timeSlotId
                                                              ),
                                                          },
                                                        ]}
                                                      >
                                                        <TimePicker
                                                          className="custom-timepicker text-center"
                                                          use12Hours
                                                          format="h A"
                                                          minuteStep={60}
                                                          hideDisabledOptions
                                                          placeholder="Hour"
                                                          onChange={(e) =>
                                                            handleClinicStartTimeChange(
                                                              e,
                                                              item?.timeSlotId
                                                            )
                                                          }
                                                          inputReadOnly={true}
                                                        />
                                                      </Form.Item>
                                                    </Col>
                                                    <Col lg={6} xs={6}>
                                                      <Form.Item
                                                        name={`visit_start_timeMin${item?.timeSlotId}`}
                                                        rules={[
                                                          {
                                                            required: true,
                                                            message:
                                                              "Start time is required",
                                                          },
                                                        ]}
                                                      >
                                                        <TimePicker
                                                          className="custom-timepicker text-center"
                                                          format="mm"
                                                          placeholder="Minutes"
                                                          inputReadOnly={true}
                                                        />
                                                      </Form.Item>
                                                    </Col>
                                                  </Row>
                                                </Col>
                                                <Col
                                                  xs={12}
                                                  md={6}
                                                  lg={6}
                                                  className="selectBox"
                                                >
                                                  <div className="d-flex justify-content-between dltbtnSet">
                                                    <label>End Time*</label>

                                                    {!isMobile &&
                                                      clinicTimeSlots.filter(
                                                        (s) =>
                                                          s.slotsId ===
                                                          slot?.slotsId
                                                      ).length > 1 && (
                                                        <button
                                                          type="button"
                                                          className="last buttonSetTime"
                                                          onClick={(e) =>
                                                            deleteClinicTimeSlot(
                                                              e,
                                                              slot?.slotsId,
                                                              item?.timeSlotId
                                                            )
                                                          }
                                                        >
                                                          <img
                                                            src={deleteIcon}
                                                            alt="Delete"
                                                            className="img-fluid"
                                                          />
                                                        </button>
                                                      )}
                                                  </div>
                                                  <Row>
                                                    <Col lg={6} xs={6}>
                                                      <Form.Item
                                                        name={`visit_end_time${item?.timeSlotId}`}
                                                        label=""
                                                        rules={[
                                                          {
                                                            required: true,
                                                            message:
                                                              "End time is required",
                                                          },
                                                          {
                                                            validator:
                                                              validateClinicEndTime(
                                                                item?.timeSlotId
                                                              ),
                                                          },
                                                        ]}
                                                      >
                                                        <TimePicker
                                                          className="custom-timepicker text-center"
                                                          use12Hours
                                                          format="h A"
                                                          minuteStep={60}
                                                          hideDisabledOptions
                                                          placeholder="Hour"
                                                          onChange={(e) =>
                                                            handleClinicEndTimeChange(
                                                              e,
                                                              item?.timeSlotId
                                                            )
                                                          }
                                                          inputReadOnly={true}
                                                        />
                                                      </Form.Item>
                                                    </Col>
                                                    <Col lg={6} xs={6}>
                                                      <Form.Item
                                                        name={`visit_end_timemin${item?.timeSlotId}`}
                                                        rules={[
                                                          {
                                                            required: true,
                                                            message:
                                                              "End time is required",
                                                          },
                                                        ]}
                                                      >
                                                        <TimePicker
                                                          className="custom-timepicker text-center"
                                                          format="mm"
                                                          placeholder="Minutes"
                                                          inputReadOnly={true}
                                                        />
                                                      </Form.Item>
                                                    </Col>
                                                  </Row>
                                                </Col>
                                              </Row>
                                            </>
                                          );
                                        }
                                      })}
                                      {/* {isBrowser ? ( */}
                                      <Col md={12} lg={12} className="">
                                        <div className="add_moretime text-end">
                                          <Button
                                            className="btn btn_add"
                                            onClick={(e) =>
                                              addClinicTimeSlot(
                                                e,
                                                1,
                                                slot?.slotsId
                                              )
                                            }
                                          >
                                            <img src={plusIcon} alt="Add" /> Add
                                            Slots
                                          </Button>
                                          {/* <Button className="btn btn_add" onClick={(e) => addVideoSlot(e, 1)}>
                                <img src={plusIcon} alt="Add" /> Add more time
                              </Button> */}
                                        </div>
                                      </Col>
                                      {/* ) : null} */}
                                      {/* {isMobile ? (
                                      <Col md={12} lg={12} className="d-flex">
                                        <div className="add_moretime text-end">
                                          <Button className="btn btn_add ms-auto" onClick={(e) => addVideoTimeSlot(e, 1, slot?.slotsId)}>
                                <img src={plusIcon} alt="Add" /> Add time
                              </Button>
                                          <Button className="btn btn_add " onClick={(e) => addClinicSlot(e, 1)}>
                                            
                                            <img src={plusIcon} alt="Add" /> Add Days
                                          </Button>
                                        </div>
                                      </Col>
                                    ) : null} */}
                                    </Col>
                                  </div>
                                </Row>
                              ))}
                            </Row>
                          ) : (
                            <div key={row?.id} className="duplicate_row_days">
                              <Col
                                md={6}
                                lg={6}
                                className="selectBox clinicB0x"
                              >
                                <Form.Item
                                  name={`visit_clinic_id`}
                                  label="Clinic/Hospital* "
                                  rules={[
                                    {
                                      required: true,
                                      message: "Clinic/Hospital is required",
                                    },
                                  ]}
                                >
                                  <Select
                                    showSearch
                                    filterOption={(input, option) =>
                                      option.props.children
                                        .toLowerCase()
                                        .startsWith(input.toLowerCase())
                                    }
                                    onChange={(value) => {
                                      setHospital(value);
                                    }}
                                    placeholder="Select"
                                  >
                                    {clinics.map((option) => (
                                      <Option
                                        key={option?.value}
                                        value={option?.id}
                                      >
                                        {option?.name}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </Col>
                              <Col md={6} lg={6} className="clinicLocation ">
                                <Form.Item
                                  name={`visit_clinic_location`}
                                  label="Area"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Location is required",
                                    },
                                    { validator: validateLocationNumber },
                                  ]}
                                >
                                  <Input
                                    className={
                                      redField === true ? "locationInput" : ""
                                    }
                                    placeholder="Select area"
                                  />
                                </Form.Item>
                              </Col>
                              <Col md={6} lg={6} className="selectBox ">
                                <Form.Item
                                  name={`clinic_visit_mins`}
                                  label="Duration "
                                  rules={[
                                    {
                                      required: true,
                                      message:
                                        "Consultation duration is required",
                                    },
                                  ]}
                                >
                                  <Select placeholder="Please select">
                                    {consultationMinutes?.length > 0 &&
                                      consultationMinutes?.map((item) => (
                                        <>
                                          <Option value={item?.id}>
                                            {item?.label} mins
                                          </Option>
                                        </>
                                      ))}
                                  </Select>
                                </Form.Item>
                              </Col>
                              <Col md={6} lg={6} className="selectBox ">
                                <Form.Item
                                  name={`visit_consultation_fee`}
                                  label="Consultation Fee*"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Consultation fee is required",
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder="Enter fee"
                                    maxLength={5}
                                    onKeyDown={(evt) =>
                                      arrayWithoutNumber.includes(evt.key) &&
                                      evt.preventDefault()
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              {clinicSlots?.map((slot, index) => (
                                <Row key={index} className="duplicate_row_days">
                                  <Col lg={12}>
                                    {index === 0 ? (
                                      /* Render content for the first row */
                                      <Col
                                        lg={12}
                                        md={12}
                                        className="text-end "
                                      >
                                        <Row>
                                          <Col
                                            lg={12}
                                            md={12}
                                            className="mx-auto"
                                          >
                                            <hr />
                                          </Col>
                                        </Row>
                                        {/* Your content for the first row */}
                                      </Col>
                                    ) : (
                                      /* Render content for other rows */
                                      <Col
                                        lg={12}
                                        md={12}
                                        className="text-end "
                                      >
                                        <Row>
                                          <Col
                                            lg={12}
                                            md={12}
                                            className="mx-auto"
                                          >
                                            <hr />
                                          </Col>
                                        </Row>

                                        <button className="last">
                                          <img
                                            src={deleteIcon}
                                            alt="Delete"
                                            onClick={(e) =>
                                              deleteClinicSlot(e, slot?.slotsId)
                                            }
                                            className="img-fluid"
                                          />
                                        </button>
                                      </Col>
                                    )}
                                  </Col>
                                  <Col md={12} lg={12} className="aa">
                                    {index === 0 && (
                                      <div className="addDays mb-3">
                                        <Button
                                          className="btn btn_add "
                                          onClick={(e) => addClinicSlot(e, 1)}
                                        >
                                          <img src={plusIcon} alt="Add" /> Add
                                          Days
                                        </Button>
                                      </div>
                                    )}
                                    <Form.Item
                                      name={`visit-day${slot?.slotsId}`}
                                      label="Consultation Days "
                                      type="array"
                                      rules={[
                                        {
                                          validator: (_, value) => {
                                            if (!value || value.length === 0) {
                                              return Promise.reject(
                                                "At least one consultation day is required"
                                              );
                                            }
                                            return Promise.resolve();
                                          },
                                        },
                                      ]}
                                    >
                                      <Radio.Group
                                        className={`radio_blue  ${
                                          isMobile
                                            ? "scrollable days-container"
                                            : ""
                                        }`}
                                        onChange={(e) =>
                                          setLocalClinicSlots(
                                            true,
                                            e.target.value,
                                            1,
                                            slot?.slotsId
                                          )
                                        }
                                        value={
                                          clinicTimeSlots.find(
                                            (s) => s.slotsId === slot?.slotsId
                                          )?.day || null
                                        }
                                      >
                                        {[
                                          "monday",
                                          "tuesday",
                                          "wednesday",
                                          "thursday",
                                          "friday",
                                          "saturday",
                                          "sunday",
                                        ].map((day) => (
                                          <Radio.Button key={day} value={day}>
                                            <div className="days">
                                              {!isMobile
                                                ? day
                                                    .slice(0, 3)
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                  day.slice(1, 3)
                                                : day.slice(0, 3)}
                                            </div>
                                          </Radio.Button>
                                        ))}
                                      </Radio.Group>
                                    </Form.Item>
                                  </Col>
                                  <div className="position-relative">
                                    <Col md={12} lg={12} className="">
                                      {clinicTimeSlots?.map((item, index1) => {
                                        if (
                                          item?.slotsId === slot?.slotsId &&
                                          item?.clinicId === 1
                                        ) {
                                          return (
                                            <>
                                              <Row
                                                key={index1}
                                                className={`duplicate_row_time ${
                                                  isMobile ? "flex-column" : ""
                                                }`}
                                              >
                                                <Col
                                                  xs={12}
                                                  md={6}
                                                  lg={6}
                                                  className="selectBox "
                                                >
                                                  <div className="d-flex justify-content-between dltbtnSet">
                                                    <label>Start Time*</label>
                                                    {isMobile &&
                                                      index1 !== 0 && (
                                                        <button
                                                          type="button"
                                                          className="last buttonSetTime"
                                                        >
                                                          <img
                                                            src={deleteIcon}
                                                            alt="Delete"
                                                            onClick={(e) => {
                                                              deleteClinicTimeSlot(
                                                                e,
                                                                slot?.slotsId,
                                                                clinicTimeSlots?.length
                                                              );
                                                            }}
                                                            className="img-fluid"
                                                          />
                                                        </button>
                                                      )}
                                                  </div>

                                                  <Row
                                                    className={`${
                                                      isMobile ? "flex-row" : ""
                                                    }`}
                                                  >
                                                    <Col lg={6} xs={6}>
                                                      <Form.Item
                                                        name={`visit_start_time${item?.timeSlotId}`}
                                                        rules={[
                                                          {
                                                            required: true,
                                                            message:
                                                              "Start time is required",
                                                          },
                                                          {
                                                            validator:
                                                              validateClinicStartTime(
                                                                item?.timeSlotId
                                                              ),
                                                          },
                                                        ]}
                                                      >
                                                        <TimePicker
                                                          className="custom-timepicker text-center"
                                                          use12Hours
                                                          format="h A"
                                                          minuteStep={60}
                                                          placeholder="Hour"
                                                          hideDisabledOptions
                                                          onChange={(e) =>
                                                            handleClinicStartTimeChange(
                                                              e,
                                                              item?.timeSlotId
                                                            )
                                                          }
                                                          inputReadOnly={true}
                                                        />
                                                      </Form.Item>
                                                    </Col>
                                                    <Col lg={6} xs={6}>
                                                      <Form.Item
                                                        name={`visit_start_timeMin${item?.timeSlotId}`}
                                                        rules={[
                                                          {
                                                            required: true,
                                                            message:
                                                              "Start time is required",
                                                          },
                                                        ]}
                                                      >
                                                        <TimePicker
                                                          className="custom-timepicker text-center"
                                                          format="mm"
                                                          placeholder="Minutes"
                                                          inputReadOnly={true}
                                                        />
                                                      </Form.Item>
                                                    </Col>
                                                  </Row>
                                                </Col>
                                                <Col
                                                  xs={12}
                                                  md={6}
                                                  lg={6}
                                                  className="selectBox"
                                                >
                                                  <div className="d-flex justify-content-between dltbtnSet">
                                                    <label>End Time*</label>

                                                    {!isMobile &&
                                                      index1 !== 0 && (
                                                        <button
                                                          type="button"
                                                          className="last buttonSetTime"
                                                        >
                                                          <img
                                                            src={deleteIcon}
                                                            alt="Delete"
                                                            onClick={(e) =>
                                                              deleteClinicTimeSlot(
                                                                e,
                                                                slot?.slotsId,
                                                                item?.timeSlotId
                                                              )
                                                            }
                                                            className="img-fluid"
                                                          />
                                                        </button>
                                                      )}
                                                  </div>
                                                  <Row>
                                                    <Col lg={6} xs={6}>
                                                      <Form.Item
                                                        name={`visit_end_time${item?.timeSlotId}`}
                                                        label=""
                                                        rules={[
                                                          {
                                                            required: true,
                                                            message:
                                                              "End time is required",
                                                          },
                                                          {
                                                            validator:
                                                              validateClinicEndTime(
                                                                item?.timeSlotId
                                                              ),
                                                          },
                                                        ]}
                                                      >
                                                        <TimePicker
                                                          className="custom-timepicker text-center"
                                                          use12Hours
                                                          format="h A"
                                                          minuteStep={60}
                                                          hideDisabledOptions
                                                          placeholder="Hour"
                                                          onChange={(e) =>
                                                            handleClinicEndTimeChange(
                                                              e,
                                                              item?.timeSlotId
                                                            )
                                                          }
                                                          inputReadOnly={true}
                                                        />
                                                      </Form.Item>
                                                    </Col>
                                                    <Col lg={6} xs={6}>
                                                      <Form.Item
                                                        name={`visit_end_timemin${item?.timeSlotId}`}
                                                        rules={[
                                                          {
                                                            required: true,
                                                            message:
                                                              "End time is required",
                                                          },
                                                        ]}
                                                      >
                                                        <TimePicker
                                                          className="custom-timepicker text-center"
                                                          format="mm"
                                                          placeholder="Minutes"
                                                          inputReadOnly={true}
                                                        />
                                                      </Form.Item>
                                                    </Col>
                                                  </Row>
                                                </Col>
                                              </Row>
                                            </>
                                          );
                                        }
                                      })}
                                      {/* {isBrowser ? ( */}
                                      <Col md={12} lg={12} className="">
                                        <div className="add_moretime text-end">
                                          <Button
                                            className="btn btn_add"
                                            onClick={(e) =>
                                              addClinicTimeSlot(
                                                e,
                                                1,
                                                slot?.slotsId
                                              )
                                            }
                                          >
                                            <img src={plusIcon} alt="Add" /> Add
                                            Slots
                                          </Button>
                                          {/* <Button className="btn btn_add" onClick={(e) => addVideoSlot(e, 1)}>
                                <img src={plusIcon} alt="Add" /> Add more time
                              </Button> */}
                                        </div>
                                      </Col>
                                      {/* ) : null} */}
                                      {/* {isMobile ? (
                                      <Col md={12} lg={12} className="d-flex">
                                        <div className="add_moretime text-end">
                                          <Button className="btn btn_add ms-auto" onClick={(e) => addVideoTimeSlot(e, 1, slot?.slotsId)}>
                                <img src={plusIcon} alt="Add" /> Add time
                              </Button>
                                          <Button className="btn btn_add " onClick={(e) => addClinicSlot(e, 1)}>
                                            
                                            <img src={plusIcon} alt="Add" /> Add Days
                                          </Button>
                                        </div>
                                      </Col>
                                    ) : null} */}
                                    </Col>
                                  </div>
                                </Row>
                              ))}
                            </div>
                          )
                        )}
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>
          )}
        </Col>
      </Row>
    </StyledVideoConsultation>
  );
};

export const StyledVideoConsultation = styled.section`
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }

  .clinicBox .ant-select-selection-search input#visit-clinic_id1 {
    margin-top: 8px;
  }

  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }

  .locationInput {
    color: #ff4d4f !important;
  }
`;

export default VideoConsultation;
